import { render, staticRenderFns } from "./PasswordModel.vue?vue&type=template&id=665fa790&scoped=true"
import script from "./PasswordModel.vue?vue&type=script&lang=js"
export * from "./PasswordModel.vue?vue&type=script&lang=js"
import style0 from "./PasswordModel.vue?vue&type=style&index=0&id=665fa790&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665fa790",
  null
  
)

export default component.exports